import { SettingsLayout } from "@/components/settings-layout";
import { QuickBooksTab } from "@/components/settings/quickbooks-tab";
import { authClient } from "@/lib/auth-client";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/settings/quickbooks")({
	// Server-side tRPC procedures already enforce admin; this is a UX sweetener
	// to avoid a flash of admin UI for non-admins who type the URL.
	beforeLoad: async () => {
		const { data: session } = await authClient.getSession();
		if (session?.user?.role !== "admin") {
			throw redirect({ to: "/" });
		}
	},
	component: QuickBooksSettingsPage,
});

function QuickBooksSettingsPage() {
	return (
		<SettingsLayout>
			<SectionHeader
				title="QuickBooks"
				description="Connect and manage your QuickBooks Online integration."
			/>
			<QuickBooksTab />
		</SettingsLayout>
	);
}

function SectionHeader({ title, description }: { title: string; description: string }) {
	return (
		<div>
			<h2 className="text-lg font-semibold text-[#1e1e20]">{title}</h2>
			<p className="mt-1 text-sm text-[#6b7280]">{description}</p>
		</div>
	);
}
